import React, { useState, useEffect, useRef } from 'react';
import { useMediaQuery } from '@react-hook/media-query';
import Nabvar from '../Components/Navbar/Navbar'
import Demo from '../Pages/Demo/Demo'
import MobileNav from '../Components/MobileNav/MobileNav'
import Cart from '../Components/Cart/Cart'

export default function IndexLayout() {
    const cartRef = useRef(null);
    const isScreenLarge = useMediaQuery('(min-width: 900px)');

    const handleCartOpen = () => {
        if (cartRef.current && cartRef.current.openCart) {
            cartRef.current.openCart();
        }
    };

    return (
        <div className='section-bg-color main-wrapper'>
            <Nabvar />
            {isScreenLarge ? (
                <>
                    <div className='espaciobg'></div>
                    <Demo />
                    <Cart ref={cartRef} />
                </>
            ) : (
                <>
                    <div className='espaciobg'></div>
                    <Demo />
                    <Cart ref={cartRef} />
                    <MobileNav onCartOpen={handleCartOpen} />
                </>
            )}
        </div>
    );
}
